import script from "./HomePageLeftMenuRender.vue?vue&type=script&lang=ts&setup=true"
export * from "./HomePageLeftMenuRender.vue?vue&type=script&lang=ts&setup=true"

import "./HomePageLeftMenuRender.vue?vue&type=style&index=0&id=5cfa1c2b&lang=css"

const __exports__ = script;

export default __exports__